<template>
  <!-- PC版本 -->
  <ContactUsForPc v-if="!isMobile" :key="locale" />

  <!-- Mobile版本 -->
  <div v-else>
    <MobileContactUs :key="locale" />
  </div>
</template>

<script setup lang="ts">
import { useDeviceDetection } from "@/utils/deviceDetection";
import ContactUsForPc from "../components/ContactUsForPc.vue";
import MobileContactUs from "../components/MobileContactUs.vue";
import { useI18n } from 'vue-i18n';
import { useHead } from '@vueuse/head';
import { computed } from 'vue';
import { getSEO } from '../utils/seoConfig';

const { isMobile } = useDeviceDetection();
const { locale } = useI18n();

// 动态多语言 SEO
const seo = computed(() => getSEO(locale.value, 'contact'));

useHead({
  title: computed(() => seo.value.title),
  meta: [
    { name: 'description', content: computed(() => seo.value.description) },
    { name: 'keywords', content: computed(() => seo.value.keywords) },
    { property: 'og:title', content: computed(() => seo.value.title) },
    { property: 'og:description', content: computed(() => seo.value.description) },
  ],
});
</script>
